var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSize34 = function SvgIconSize34(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 22,
    x: 1.5,
    y: 1,
    stroke: "#777E90",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FD",
    d: "M.5 6h19v12H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M4.088 16.716c-.656 0-1.212-.128-1.668-.384a2.67 2.67 0 0 1-1.044-1.02 2.829 2.829 0 0 1-.348-1.38h1.128c0 .544.172.976.516 1.296.352.32.824.48 1.416.48.392 0 .732-.072 1.02-.216.288-.144.512-.348.672-.612.16-.272.24-.588.24-.948 0-.544-.176-.984-.528-1.32-.344-.336-.808-.504-1.392-.504-.248 0-.464.032-.648.096a1.94 1.94 0 0 0-.468.216l-.576-1.032L5.756 8.94l-.12-.216h-4.26V7.74h5.34v1.596l-2.772 2.016-.84.036a3.25 3.25 0 0 1 .444-.12c.168-.032.364-.048.588-.048.64 0 1.184.12 1.632.36.448.24.788.56 1.02.96.24.4.36.836.36 1.308v.168a2.636 2.636 0 0 1-1.392 2.316c-.448.256-1.004.384-1.668.384Zm4.66-.216v-1.464h1.391V16.5H8.747Zm0-4.44v-1.464h1.391v1.464H8.747Zm2.84 2.364v-1.416l3.636-5.484.804.636-3.396 5.136.108.216h5.664v.912h-6.816ZM16.16 16.5v-6.204h1.08V16.5h-1.08Z"
  })));
};
export default SvgIconSize34;